import { isSameDay, isValid, isBefore } from "date-fns";
import { addMinutes } from 'date-fns/fp';
//VaP - dodelat pripadne i dalsi funkce viz napr.
//isSameDay, isSameMonth, isWeekend, addDays, addMonths, startOfMonth, startOfISOWeek, eachDayOfInterval, isBefore, isAfter, min, max 
//parse, isValid, lightFormat 
//isValid, parseISO, lightFormat, startOfDay
//max, startOfDay, isValid, isWithinInterval, addDays, subDays, isBefore, isAfter, differenceInCalendarDays
//subMonths, startOfMonth, endOfMonth, compareDesc, isWithinInterval
//https://date-fns.org/docs/Getting-Started

export function tlIsSameDay(dateleft: number, dateRight: number): boolean {
	return isSameDay(dateleft, dateRight);
}


export function tlIsValid(date: any): boolean {
	return isValid(date)
}

export function tlIsBefore(date: number, dateToCompare: number): boolean {
	return isBefore(date, dateToCompare);
}

export function tlAddMinutes(minutesToAdd: number, date: number): number {
	return addMinutes(minutesToAdd, date).getTime();
}

//převod 00:00:00    na 1y 5d 8h 6m
export function tlResponseToUptimeString(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}

	var result = '';
	var time = (inputDate as String).split(':');
	if (time.length > 2) {
		var yearR = '';
		var daysR = '';
		var hoursR = '';
		var minutR = time[1] + 'm';
		var hours = Number(time[0]);
		var days = 0;
		var years = 0;

		if (hours >= 24) {
			days = (hours - (hours % 24)) / 24;
			hours = hours % 24;
			if (hours > 0) {
				hoursR = hours + 'h ';
			}

			if (days > 365) {				
				years = (days - (days % 365)) / 365;
				days = days -(years * 365);
			}
			if (days > 0) {
				daysR = days + 'd ';
			}
			if (years > 0) {
				yearR = years + 'r ';
			}
		}

		result = yearR + daysR + hoursR + minutR; 
	}
	return result;
}

//obsolete
export function tlResponseDateToFormDateTimeString(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}
	return new Date(inputDate).toLocaleDateString() + ' ' + new Date(inputDate).toLocaleTimeString();
}

//obsolete
export function tlResponseDateToFormDateString(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}
	return new Date(inputDate).toLocaleDateString();
}

//do databaze datum
export function tlDateToISOString(inputDate: Date): string {
	if (inputDate == null) {
		return '';
	}
	return inputDate.toISOString();
}

//z databaze zobrazení - do formuláře je potřeba poslat v tomto formatu: 2020-01-15
export function tlISODateToLocalStringForm(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}

	var inpDate = new Date(inputDate);
	//když nastane že smaže
	if (isNaN(inpDate.getFullYear())) {
		var inpDate = new Date();
	}
	
	var month = inpDate.getMonth() < 9 ? '0' + (inpDate.getMonth()+1) : (inpDate.getMonth()+1).toString();
	var day = inpDate.getDate() < 10 ? '0' + inpDate.getDate() : inpDate.getDate().toString();
	var result = inpDate.getFullYear() + '-' + month + '-' + day;

	while (result.length < 10) {
		result = '0' + result;
	}

	return result;
}

//připrava pro filter do formatu 2020-01-15  (už není potřeba)
export function tlPrepareForFilter(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}

	var inpDate = inputDate as String;
	var result = '';
	//vstup formátu 2020-08-02 412:12
	if (inpDate.indexOf('-') != -1) {
		return inpDate.substr(0, 10);
	}

	var char = inpDate.indexOf('.') != -1 ? '.' : '/';
	var arr = inpDate.split(char);
	if (inpDate.indexOf('.') != -1) {
		var month = Number(arr[1]) < 10 ? '0' + Number(arr[1]) : Number(arr[1]).toString();
		var day = Number(arr[0]) < 10 ? '0' + Number(arr[0]) : Number(arr[0]).toString();		
	}
	else { //anglicka
		var day = Number(arr[1]) < 10 ? '0' + Number(arr[1]) : Number(arr[1]).toString();
		var month = Number(arr[0]) < 10 ? '0' + Number(arr[0]) : Number(arr[0]).toString();
	}

	result = Number(arr[2].toString().trim().substr(0, 4)) + '-' + month + '-' + day;
	return result;
}

//z databaze zobrazení datum pouze den a měsíc 
export function tlISODateWithoutYearToLocalString(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}	
	var res = new Date(inputDate).toLocaleDateString();
	res = res.substr(0, res.length - 5);
	return res;
	
}

//z databaze zobrazení datum
export function tlISODateToLocalString(inputDate: any): string {
	if (inputDate == null || inputDate == '') {
		return '';
	}
	return new Date(inputDate).toLocaleDateString();
}

//z databaze zobrazení častka s kč
export function tlIAmountCzech(input: any): string {
	if (input == null )
	{
		input = 0;
	}
	let cislo = parseFloat(input);

	var formatter = new Intl.NumberFormat('cs-CZ', {
		style: 'currency',
		currency: 'CZK',
	});
	return formatter.format(cislo);
}


//null hodnutu zmenim na 0 aby to bylo v databazi videt
export function tlAmountZero(input: number): string {
	if (input == null)
	{
		return '';
	}

	return input + '';
}

//z databaze zobrazení datum + čas   TEXTOVY VYSTUP
export function tlISODateTimeToLocalString(inputDate: any): string {	
	if (inputDate == null || !(new Date(inputDate).getTime()  >0)) {
		return '';
	}
	return new Date(inputDate).toLocaleDateString() + ' '+ new Date(inputDate).toLocaleTimeString();
}

//z databaze zobrazení datum + čas bez sekund
export function tlISODateTimeToLocalNoSecondsString(inputDate: any): string {
	if (inputDate == null || !(new Date(inputDate).getTime() > 0)) {
		return '';
	}
	//jina verze ale nevim
	//if (inputDate == null ) {
	//	return '';
	//}

	//if (!(new Date(inputDate).getTime() > 0)) {
		
	//	return inputDate;
	//}

	return new Date(inputDate).toLocaleDateString() + ' ' + new Date(inputDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}
//TODO dat to pryc
export function tlISODateToLocalString2(inputDate: any): string {
	if (inputDate == null || !(new Date(inputDate).getTime() > 0)) {
		return '';
	}
	//jina verze ale nevim
	//if (inputDate == null ) {
	//	return '';
	//}

	//if (!(new Date(inputDate).getTime() > 0)) {

	//	return inputDate;
	//}

	return new Date(inputDate).toLocaleDateString() + ' ' + new Date(inputDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}


//do databaze čas - zatím jen připraveno
export function tlTimeToISOString(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}
	return inputDate.toISOString();
}


//z databaze zobrazení čas - do formulářů (zatim jen nachystáno až se vyřešení posun času)
export function tlISOTimeToLocalStringForm(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}

	return inputDate;
}

//z databaze zobrazení čas bez sekund
export function tlISOTimeTo24HHMMString(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}
	var datePrepare = new Date();
	var inputs = (inputDate as string).split(':');
	datePrepare.setHours(Number(inputs[0]));
	datePrepare.setMinutes(Number(inputs[1]));


	return datePrepare.toLocaleTimeString([], { hour: '2-digit', hour12: false , minute: '2-digit' });
}

//z databaze zobrazení čas bez sekund
export function tlISOTimeWithoutSecondToLocalString(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}
	var datePrepare = new Date();
	var inputs = (inputDate as string).split(':');
	datePrepare.setHours(Number(inputs[0]));
	datePrepare.setMinutes(Number(inputs[1]));


	return datePrepare.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}


//z databaze zobrazení  čas - zatim nepoužito
export function tlISOTimeToLocalString(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}
	
	var datePrepare = new Date();
	var inputs = (inputDate as string).split(':');
	datePrepare.setHours(Number(inputs[0]));
	datePrepare.setMinutes(Number(inputs[1]));


	return datePrepare.toLocaleTimeString();
}

//z databaze zobrazení času z formatu dateTime chci pouze čas
export function tlISODateTimeToTimeOnlyLocalString(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}
	var datePrepare = new Date(inputDate);
	
	return datePrepare.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

//z databaze zobrazení času z formatu dateTime chci pouze čas ve tvaru 23:59 bootstrap to takhle chce
export function tlISODateTimeToTimeOnlyString(inputDate: any): string {
	if (inputDate == null) {
		return '';
	}
	var datePrepare = new Date(inputDate);
	var res = timeHelper(datePrepare.getHours()) + ':' + timeHelper(datePrepare.getMinutes());
	return res;
	
}

//vrací název měsíce z param: 1- leden - podle jazyku
export function tlNameMonthToLocalString(inputMonth: any): string {
	if (inputMonth == null) {
		return '';
	}
	var today = new Date();
	var month = Number(inputMonth) - 1;
	today = new Date(2000, month, 1);
	var name = today.toLocaleString('default', { month: 'long' });

	return name ;
}


//vrací název měsíce z param: 1- leden - čeština
export function tlNameMonthToCzechString(inputMonth: any): string {
	if (inputMonth == null) {
		return '';
	}
	var today = new Date();
	var month = Number(inputMonth) - 1;
	today = new Date(2000, month, 1);
	var name = today.toLocaleString('cs-CZ', { month: 'long' });

	return name;
}

//pomocná metoda ... 1  na 01
export function timeHelper(numb: number) {
	var result = numb < 10 ? '0' + numb : numb.toString();
	return result;
}

//z databaze zobrazení datum + čas + zona  TEXTOVY VYSTUP
//2025-02-04T19:58:16+10:00 => 4.2.2025 19:58:16 +10:00
export function tlISOLocalDateTimeToZoneString(inputDate: string): string {
	if (inputDate == null || inputDate.length < 16)
		return '';
	
	var offsetString = inputDate.slice(-6);
	if (offsetString.startsWith('+') || offsetString.startsWith('-'))
		inputDate = inputDate.slice(0, -6);
	else
		offsetString = '';

	const date = new Date(inputDate);
	if (date.getTime() < 0)
		return '';

	return `${date.toLocaleDateString()} ${date.toLocaleTimeString()} ${offsetString}`;
}